/** URLs officielles « partager » (LinkedIn, Facebook, X) avec encodage correct. */
export function buildPodcastSocialShareUrls(url: string, title: string) {
  const encUrl = encodeURIComponent(url);
  const encText = encodeURIComponent(title.trim() || 'Podcast');
  return {
    linkedIn: `https://www.linkedin.com/sharing/share-offsite/?url=${encUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${encUrl}&text=${encText}`,
  } as const;
}
